export default __webpack_public_path__ + "static/media/gallery_02.0ec12054.jpg";